import { render, staticRenderFns } from "./LmVoiceRecognition.vue?vue&type=template&id=8696e642&"
import script from "./LmVoiceRecognition.vue?vue&type=script&lang=js&"
export * from "./LmVoiceRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports